<div class="modal-header">
  <h3 class="modal-title">System-Form Acct Mapping</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="divShadow">
    <form class="form-horizontal" novalidate>

      @if (loadingFirSysAcct) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
      </div>
}

      @if (!loadingFirSysAcct) {
<div>
        <div style="display: flex; gap: 15px; padding-bottom: 15px;">
          <div style="flex: 0 0 16%;">
            <label>Acct Type:</label>
            <input type="text" class="form-control" [value]="firSystemAcctDetails.acct_type" readonly>
          </div>
          <div style="flex: 1;">
            <label>System Account</label>
            <div class="custom-select-display">
              <span>{{fir_sys_acct_selected}}</span>
            </div>
          </div>
        </div>
      </div>
}

      @if (loadingFirLookup) {
<div class="formLoader" style="text-align: center;">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
      </div>
}

      @if (!loadingFirLookup) {
<div class="panel panel-default">
        <div class="panel-heading">
          @if (showFirDetailsText === 'lookup') {
<span>Lookup for System Acct to Form Line Mapping</span>
}
          @if (showFirDetailsText === 'edit') {
<span>Edit System Acct to Form Line Mapping</span>
}
          @if (showFirDetailsText === 'add') {
<span>Add System Acct to Form Line Mapping</span>
}
          <i class="glyphicon" [ngClass]="{'glyphicon-chevron-down': firLookUpMapping, 'glyphicon-chevron-up': !firLookUpMapping}"
             style="float: right; cursor: pointer; margin-right: 20px;" (click)="firToggleLookup()"></i>
          <div class="btn btn-success btn-xs" style="display: inline-block; float: right; margin-right: 15px; width: 120px;"
               (click)="firToggleLookup()">Lookup</div>
          <div class="btn btn-success btn-xs" style="display: inline-block; float: right; margin-right: 15px; width: 120px;"
               (click)="firFormAdd()">Add</div>
        </div>

        @if (firLookUpMapping) {
<div class="panel-body">
          <div style="display: flex; gap: 10px; flex-wrap: wrap;">
            <div style="flex: 0 0 15%;">
              <label>IRS Form</label>
              <select class="form-control" [(ngModel)]="CHECK_FIR_FORM" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="getFirLookupNext(1, 'SCHEDULE', CHECK_FIR_FORM); firFormchanged()">
                <option value="">Select...</option>
                @for (f of firLookupForm; track $index) {
<option [value]="f">{{f}}</option>
}
              </select>
            </div>
            <div style="flex: 0 0 15%;">
              <label>Schedule</label>
              <select class="form-control" [(ngModel)]="CHECK_FIR_SCHEDULE" [ngModelOptions]="{standalone: true}"
                      [disabled]="!CHECK_FIR_FORM"
                      (ngModelChange)="getFirLookupNext(2, 'LINE', CHECK_FIR_SCHEDULE); firSchedulechanged()">
                <option value="">Select...</option>
                @for (s of firLookupSchedule; track $index) {
<option [value]="s">{{s}}</option>
}
              </select>
            </div>
            <div style="flex: 0 0 20%;">
              <label>Line</label>
              <select class="form-control" [(ngModel)]="CHECK_FIR_LINE" [ngModelOptions]="{standalone: true}"
                      [disabled]="!CHECK_FIR_SCHEDULE"
                      (ngModelChange)="getFirLookupNext(3, 'COL', CHECK_FIR_LINE); firLinechanged()">
                <option value="">Select...</option>
                @for (l of firLookupLine; track $index) {
<option [value]="l">{{l}}</option>
}
              </select>
            </div>
            <div style="flex: 0 0 10%;">
              <label>Column</label>
              <select class="form-control" [(ngModel)]="CHECK_FIR_COL" [ngModelOptions]="{standalone: true}"
                      [disabled]="!CHECK_FIR_LINE"
                      (ngModelChange)="getFirLookupNext(4, 'SYS_ACCT', CHECK_FIR_COL)">
                <option value="">Select...</option>
                @for (c of firLookupColumn; track $index) {
<option [value]="c">{{c}}</option>
}
              </select>
            </div>
            <div style="flex: 0 0 30%;">
              <label>Mapped System Accounts</label>
              @if (showFirDetailsText === 'lookup') {
<div>
                <select class="form-control" [(ngModel)]="CHECK_FIR_SYS_MAP_ACCT" [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FIR_LINE">
                  <option value="">Select...</option>
                  @for (m of firLookupSysMapAcct; track $index) {
<option [value]="m">{{m}}</option>
}
                </select>
              </div>
}
              @if (showFirDetailsText === 'edit' || showFirDetailsText === 'add') {
<div class="custom-select-display">
                <span>{{CHECK_FIR_SYS_MAP_ACCT}}</span>
              </div>
}
            </div>
          </div>
        </div>
}
      </div>
}

      <div class="modal-footer">
        <button class="save-button" type="button" (click)="save()"
                [disabled]="showFirDetailsText === 'lookup' || crudLoading">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button class="reset-button" type="button" (click)="reset()">Reset</button>
        <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>

@if (firIRSFormData && firIRSFormData.length > 0) {
<div [hidden]="minimise"
     style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px;">
  <div class="divShadow">
    <div class="table-responsive">
      @if (loadingIRSform) {
<div style="text-align: center;">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
      </div>
}
      @if (!loadingIRSform) {
<table
             class="table table-hover table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th style="text-align: center;">Action</th>
            <th>
              <i class="fa pr-5 pointer" [ngClass]="{'fa-sort': sort_key['1']===0, 'fa-sort-alpha-asc': sort_key['1']===1, 'fa-sort-alpha-desc': sort_key['1']===2}"
                 (click)="orderByField='FORM'; sortBy('1', sort_key['1'])"></i> IRS Form
            </th>
            <th>
              <i class="fa pr-5 pointer" [ngClass]="{'fa-sort': sort_key['2']===0, 'fa-sort-alpha-asc': sort_key['2']===1, 'fa-sort-alpha-desc': sort_key['2']===2}"
                 (click)="orderByField='SCHEDULE'; sortBy('2', sort_key['2'])"></i> Schedule
            </th>
            <th>
              <i class="fa pr-5 pointer" [ngClass]="{'fa-sort': sort_key['3']===0, 'fa-sort-alpha-asc': sort_key['3']===1, 'fa-sort-alpha-desc': sort_key['3']===2}"
                 (click)="orderByField='LINE'; sortBy('3', sort_key['3'])"></i> Line No
            </th>
            <th>
              <i class="fa pr-5 pointer" [ngClass]="{'fa-sort': sort_key['4']===0, 'fa-sort-alpha-asc': sort_key['4']===1, 'fa-sort-alpha-desc': sort_key['4']===2}"
                 (click)="orderByField='LINE_DESC'; sortBy('4', sort_key['4'])"></i> Line Description
            </th>
            <th>
              <i class="fa pr-5 pointer" [ngClass]="{'fa-sort': sort_key['5']===0, 'fa-sort-alpha-asc': sort_key['5']===1, 'fa-sort-alpha-desc': sort_key['5']===2}"
                 (click)="orderByField='COL'; sortBy('5', sort_key['5'])"></i> Column
            </th>
          </tr>
        </thead>
        <tbody>
          @for (t of getSortedData(); track $index; let i = $index) {
<tr>
            <td style="text-align: center;">
              @if (!loadingFirLookup) {
<i class="fa fa-edit pointer pr-5" (click)="formEdit(t, i)"></i>
}
              @if (loadingFirLookup) {
<i class="fa fa-edit pr-5" style="color: gray; cursor: not-allowed;"></i>
}
              <span><i>Edit</i></span>
            </td>
            <td>{{ t.FORMS }}</td>
            <td>{{ t.SCHEDULE }}</td>
            <td>{{ t.LINE }}</td>
            <td>{{ t.LINE_DESC }}</td>
            <td>{{ t.COL }}</td>
          </tr>
}
        </tbody>
      </table>
}
    </div>
  </div>
</div>
}
